import { string, shape, number, objectOf } from 'prop-types';

export default objectOf(
    shape({
        attributeName: string.isRequired,
        id: string.isRequired,
        label: string,
        type: string.isRequired,
        order: number,
    }),
);
